import { Block } from 'baseui/block';
// types
import { ISP_HeatingCoolingCoil } from './types'
// components
import { SmallPanel as ValveVarPanel, schema as schemaValveVar } from '../../Devices/ValveVar'
import { SmallPanel as BelimoPanel, schema as schemaBelimo } from '../../Devices/BelimoEnergyValve'
import { SmallPanel as ValvePanel, schema as schemaValve } from '../../Devices/ValveTwoPoint'
import { SmallPanel as PumpOneSpeedPanel, schemaPump, schemaPump1, schemaPump2 } from '../../Devices/DriveOneSpeed'
import { SmallPanelFreeze, schemaFreeze } from '../../Devices/SensorDigitalAlarm'
import { schemaPump as schemaPumpVar, schemaPump1 as schemaPump1Var, schemaPump2 as schemaPump2Var } from '../../Devices/DriveVarSpeed'
// api
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { IAutomationObject } from '../../types';


export function SmallPanel(props: ISP_HeatingCoolingCoil) {

        const { children } = useGetObjectsChildren(props.resourceGroupId, props.id)

        const valvevar = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaValveVar), [children]);
        const belimo = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaBelimo), [children]);
        const valve = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaValve), [children]);
        const alarm = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaFreeze), [children]);
        const pumps = useMemo(() => children?.filter((v: IAutomationObject) => v.schema === schemaPump || v.schema === schemaPump1 || v.schema === schemaPump2
                || v.schema === schemaPumpVar || v.schema === schemaPump1Var || v.schema === schemaPump2Var
        ), [children]);

        return (
                <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='20px'>
                        {pumps?.map((item: any, index: number) => (
                                <PumpOneSpeedPanel key={item.id} {...item}></PumpOneSpeedPanel>
                        ))}
                        {valvevar &&
                                <ValveVarPanel  key={valvevar.id} {...valvevar}></ValveVarPanel>
                        }
                        {belimo &&
                                <BelimoPanel key={belimo.id} {...belimo}></BelimoPanel>
                        }
                        {valve &&
                                <ValvePanel key={valve.id} {...valve}></ValvePanel>
                        }
                        {alarm &&
                                <SmallPanelFreeze key={alarm.id} {...alarm}></SmallPanelFreeze>
                        }
                </Block>
        );
}